const TitleCopyTop = ({ title, copy }: { title: React.ReactNode, copy: React.ReactNode }) => {
    return (
      <div className='title-copy-top' >
        <h2>{title}</h2>
        <p>{copy}</p>
      </div>
    )
  }

  export default TitleCopyTop;